export default {
    namespaced: true,

    state: {
        user: window.user || null,
    },

    mutations: {
        setUser(state, user) {
            state.user = user
        }
    },

    actions: {
        async getUser({state, commit, dispatch}) {

            const res = await axios.get('/api/v1/index/user')
            const {data} = res

            commit('setUser', data)
        },
    }
}
